import * as React from "react";
import ContentCard from "../../../../../ui-library/content-card/content-card";
import CardContent from "../../../../../ui-library/content-card/card-content";
import CardHeading from "../../../../../ui-library/content-card/card-heading";
import CardSubHeading from "../../../../../ui-library/content-card/card-sub-heading";
import {
  CovidCaseByCountry_covidCaseOwidByCountry_data,
  CovidCaseByCountry_covidCaseOwidByCountry_latest,
} from "../../../../../../apollo-types/CovidCaseByCountry";
import { CountryItem } from "../../../../../../types/country";
import { Colors } from "../../../../../design-tokens/colors";
import DailyCasesChartMini from "../../../../../ui-library/daily-cases-chart/daily-cases-chart-mini";
import { formatNumberDisplay } from "../../../../../../utils/format-number";
import { Fonts } from "../../../../../design-tokens/fonts";
import LoadingState from "../../../../../ui-library/loading-state/loading-state";
import { getCountryPerformance } from "../../../../../../utils/get-country-performance";
import styles from "./how-well-situation-card.styles";

interface HowWellSituationCardProps {
  benchmarkCountry?: CountryItem;
  countryName: string;
  data?: CovidCaseByCountry_covidCaseOwidByCountry_data[] | null;
  covidBenchmarkData?: CovidCaseByCountry_covidCaseOwidByCountry_data[] | null;
  lastDayValue: CovidCaseByCountry_covidCaseOwidByCountry_latest;
  loading?: boolean;
}

const HowWellSituationCard: React.FC<HowWellSituationCardProps> = ({
  benchmarkCountry,
  countryName,
  data,
  covidBenchmarkData,
  lastDayValue,
  loading,
}) => {
  const { performance, color = Colors.Pink } = getCountryPerformance({
    countryName,
    data,
  });

  return (
    <ContentCard>
      <CardContent>
        <CardHeading>How well are they doing?</CardHeading>
        <CardSubHeading>
          <span css={{ color, fontWeight: Fonts.Weight.Bold }}>
            {countryName} is {performance}
          </span>{" "}
          in comparison to other countries.
        </CardSubHeading>

        {loading && <LoadingState />}

        {data && (
          <>
            <DailyCasesChartMini
              data={data as any[]}
              benchmarkData={covidBenchmarkData as any[]}
              dataKey="averageNewCases"
              color={color}
              name="Avg new daily"
              benchmarkName={benchmarkCountry?.countryName}
              size="large"
            />
            <div css={styles.content}>
              <div css={styles.detail}>
                Total cases{" "}
                <span>{formatNumberDisplay(lastDayValue.totalCases || 0)}</span>
              </div>
              <div css={styles.detail}>
                Avg new daily{" "}
                <span>{formatNumberDisplay(lastDayValue.averageNewCases)}</span>
              </div>
            </div>
          </>
        )}
      </CardContent>
    </ContentCard>
  );
};

export default HowWellSituationCard;
